import { $wgsl } from "../../wgsl-preprocessor/wgsl-preprocessor";
import tonemap from "../chunks/tonemap.wgsl";
import hatch from "../chunks/hatch_pattern.wgsl";
import blendShader from "./blend.wgsl";
import depthReadBackCode from '../shaders/depth-readback.wgsl';

import { getBlendSettingsDeclaration, getUnProjectSettingsDeclaration } from "./BlendSettings";

/**
 * Returns the blend shader code with the given configuration.
 * @param {boolean} spatialFilterEnabled - Whether spatial filtering is enabled.
 * @param {boolean} useWboit - Whether WBOIT is used.
 * @param {boolean} categoryHighlightingEnabled - Whether category highlighting is enabled.
 * @param {boolean} categoryHighlightingFallback - Whether to use fallback (category packed in modelId upper 16 bits).
 * @returns {string} The compiled shader code.
 */
export function getBlendShader(spatialFilterEnabled, useWboit, categoryHighlightingEnabled = false, categoryHighlightingFallback = false) {
  // hasCategoryTarget: true when category highlighting uses a dedicated render target (not fallback mode)
  const hasCategoryTarget = categoryHighlightingEnabled && !categoryHighlightingFallback;
  return $wgsl(blendShader, {
    blendUniforms: getBlendSettingsDeclaration(1),
    unprojectUniforms: getUnProjectSettingsDeclaration(2),
    tonemap,
    hatch,
    spatialFilter: spatialFilterEnabled,
    depthReadBack: spatialFilterEnabled ? depthReadBackCode : '',
    useWboit,
    categoryHighlighting: categoryHighlightingEnabled,
    categoryHighlightingFallback,
    hasCategoryTarget
  });
}